import Image from 'next/image';
import {CommonLink} from '../../../../shared/components/CommonLink';
import {SectionHeader} from './Presenter/SectionHeader';
import {SPECIAL_CONTENTS} from './constants';

type SpecialContentSectionProps = {
  componentId: string;
  title: string;
  description?: string;
};

export const SpecialContentSection = ({
  componentId,
  title,
  description,
}: SpecialContentSectionProps) => {
  return (
    <div id={componentId} className="px-4 w-full pc:w-[1200px]">
      <SectionHeader
        componentId={componentId}
        title={title}
        description={description}
      />

      <div className="flex overflow-x-scroll mt-16 gap-16">
        {SPECIAL_CONTENTS.map((content) => (
          <CommonLink
            key={content.src}
            href={content.href}
            className="hover:opacity-70 flex-shrink-0 w-3/5 pc:w-auto"
            data-gtm-click={`${componentId}-item`}
          >
            <Image
              src={content.src}
              alt={content.alt}
              width={200}
              height={300}
              className="w-full h-auto"
            />
          </CommonLink>
        ))}
      </div>
    </div>
  );
};
